import { render } from "./manageStats.vue?vue&type=template&id=3a7887bb&scoped=true"
import script from "./manageStats.vue?vue&type=script&lang=js"
export * from "./manageStats.vue?vue&type=script&lang=js"

import "./manageStats.vue?vue&type=style&index=0&id=3a7887bb&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7887bb"]])

export default __exports__